import React from 'react';
import Page from 'App/components/Page';
import { useUserContext } from 'App/contexts/UserContext';
import AccessView from './AccessView';

function AccessViewPage() {
    const user = useUserContext();
    const branchName = `Active Branch: ${user?.CompanyName} - ${user.BranchName}`;
    return (
        <Page title={branchName} showPageTitle>
            <AccessView />
        </Page>
    );
}

export default AccessViewPage;
